var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import JsonView from "../../../../lib/builtin/components/JSONView";
import { Prop, Vue } from 'vue-property-decorator';
import { debounce } from "lodash-es";
let SearchableJsonView = class SearchableJsonView extends Vue {
  get debouncedInput() {
    return debounce(value => {
      this.$emit('searchInputChange', value);
    }, 500).bind(this);
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "class": "ucd-devTool-layout-propPanel-jv"
    }, [h("a-input", {
      "on": {
        "change": e => this.debouncedInput(e.target.value)
      },
      "attrs": {
        "placeholder": this.searchPlaceholder,
        "allowClear": true,
        "value": this.searchInput
      }
    }, [h("a-icon", {
      "slot": "prefix",
      "attrs": {
        "type": "search"
      }
    })]), h(JsonView, {
      "attrs": {
        "value": this.value,
        "initKey": this.initKey,
        "rootLevelKeys": this.rootLevelKeys,
        "filterStr": this.searchInput
      },
      "scopedSlots": this.$scopedSlots
    })]);
  }
};
__decorate([Prop({
  type: String,
  default: ''
})], SearchableJsonView.prototype, "searchInput", void 0);
__decorate([Prop({
  type: Object,
  default: null
})], SearchableJsonView.prototype, "value", void 0);
__decorate([Prop({
  type: String,
  default: ''
})], SearchableJsonView.prototype, "initKey", void 0);
__decorate([Prop({
  type: Array,
  default: () => []
})], SearchableJsonView.prototype, "rootLevelKeys", void 0);
__decorate([Prop({
  type: String,
  default: '搜索'
})], SearchableJsonView.prototype, "searchPlaceholder", void 0);
SearchableJsonView = __decorate([Component({
  name: 'SearchableJsonView'
})], SearchableJsonView);
export default SearchableJsonView;
//# sourceMappingURL=SearchableJsonView.js.map
